export function getMaskedPhone(phone: string): string {
  return `${phone.slice(0, 3)} XXX XXX ${phone.slice(9)}`;
}
